
export default function LandingPage() {
  return (
    <iframe
      src="/landing/index.html"
      style={{
        width: '100%',
        height: '100vh',
        border: 'none',
        display: 'block',
      }}
      scrolling="yes"
    />
  );
}
